import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Feature } from '@igo2/geo';
import { Constantes } from 'src/app/shared/constantes';
import { RechercheGdfService } from 'src/app/shared/services/recherche-gdf.service';
import { SIGTRechercheGdfBaseComponent } from '../_sigt-recherche-gdf.base.component';
import { or } from 'ol/format/filter';
import { EntityTableTemplate } from '@igo2/common/entity';
import { LanguageService } from '@igo2/core/language';
import { MessageService } from '@igo2/core/message';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import * as olstyle from 'ol/style';
import Filter from 'ol/format/filter/Filter';
import IsLike from 'ol/format/filter/IsLike';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-avis-prise-prossession-gdf',
    templateUrl: './avis-prise-prossession-gdf.component.html',
    styleUrls: ['./avis-prise-prossession-gdf.component.scss'],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        MatInputModule,
        TranslateModule,
        MatFormFieldModule,
        MatButtonModule
    ]
})
export class AvisPriseProssessionGdfComponent extends SIGTRechercheGdfBaseComponent implements OnInit {
  propertyKeyAndTitle: { [key: string]: string };
  template: EntityTableTemplate;

  form: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    languageService: LanguageService,
    rechercherGdfService: RechercheGdfService,
    httpClient: HttpClient,
    messageService: MessageService,
    cdRef: ChangeDetectorRef
  ) {
    super(rechercherGdfService, httpClient, messageService, languageService, cdRef);
    this.propertyKeyAndTitle = this.rechercherGdfService.getPropertyKeyAndTitle('avisPriseProssessionGdf');
    this.template =  this.rechercherGdfService.getEntityTableTemplate('avisPriseProssessionGdf');
  }

  ngOnInit(): void {
    this.style = new olstyle.Style({
      stroke: new olstyle.Stroke({
        width: 1,
        color: [0, 0, 0, 1]
      }),
      fill: new olstyle.Fill({
        color: [254, 178, 76, 1]
      }),
      image: new olstyle.Circle({
        radius: 4.5,
        stroke: new olstyle.Stroke({
          width: 1,
          color: [0, 0, 0, 1]
        }),
        fill: new olstyle.Fill({
          color: [254, 178, 76, 1]
        })
      })
    });
    this.getLayer("AvisPossession");
    this.form = this.formBuilder.group({
      numero: ["", [Validators.required, this.validerNonEspaceSeul]]
    });

    this.messageApplication.grilleVide = Constantes.MessageApplicatif.AucunElement_6I;
    this.messageApplication.erreurCouche = Constantes.MessageApplicatif.CoucheIndisponible_16T;
    this.messageApplication.obligatoireNumero = Constantes.MessageApplicatif.ValeurObligatoire_1E
      .replace("{0}", this.getCleanKey('avisPriseProssessionGdf.numero'));
  }

  formaterChampsFeaturePourResultatRecherche(features: Feature[]): Feature[] {
    return this.rechercherGdfService.formatFeaturesForTable('avisPriseProssessionGdf', features);
  }

  buildFilter(): Filter {
    let filters: Filter[] = [];
    let numero = this.supprimerZeroAuDebut(this.form.get("numero").value);
    filters.push(new IsLike('OSD_NO_AVIS', numero + '%', "%", undefined, undefined, false));
    filters.push(new IsLike('OSD_NO_AVIS', '0' + numero + '%', "%", undefined, undefined, false));
    filters.push(new IsLike('OSD_NO_AVIS', '00' + numero + '%', "%", undefined, undefined, false));
    filters.push(new IsLike('OSD_NO_AVIS', '000' + numero + '%', "%", undefined, undefined, false));
    filters.push(new IsLike('OSD_NO_AVIS', '0000' + numero + '%', "%", undefined, undefined, false));
    return or(...filters);
  }

  initialiserChamps(): void {
    this.form.setValue({
      numero: ''
    });
    this.form.get('numero').setErrors(null, { emitEvent: false });
  }
}
